module.exports = __webpack_public_path__ + "static/media/Gilroy-SemiBold.5b057a22.otf";